import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Xlsx: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[34px] h-[40px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="40"
    viewBox="0 0 34 40"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4C0 2.93913 0.421427 1.92172 1.17157 1.17157C1.92172 0.421427 2.93913 0 4 0H23.333L33.333 10V36C33.333 37.0609 32.9116 38.0783 32.1614 38.8284C31.4113 39.5786 30.3939 40 29.333 40H4C2.93913 40 1.92172 39.5786 1.17157 38.8284C0.421427 38.0783 0 37.0609 0 36V4Z"
      fill="url(#paint0_linear_1492_2564)"
    />
    <path
      d="M26.6918 9.9901C25.8147 9.9901 24.9735 9.64169 24.3534 9.02151C23.7332 8.40132 23.3848 7.56017 23.3848 6.6831V0.0581055L33.3308 9.9901H26.6908H26.6918Z"
      fill="#16613F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33203 14.167H13.332V11.667H8.33203V14.167ZM13.332 18.333H8.33203V15.833H13.332V18.333ZM13.332 22.5H8.33203V20H13.332V22.5ZM24.999 18.333H14.999V15.833H24.999V18.333ZM14.999 22.5H24.999V20H14.999V22.5ZM14.999 14.167V11.667H24.999V14.167H14.999Z"
      fill="white"
      fillOpacity="0.4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6507 36.25H14.4607V31.252H15.6507V36.25ZM11.5269 36.2502H10.2109L11.4709 34.3462L10.3159 32.6172H11.6319L12.1429 33.4852L12.6539 32.6172H13.9139L12.7799 34.3252L14.0679 36.2502H12.7519L12.1219 35.2002L11.5269 36.2502ZM16.28 35.0532C16.315 36.0682 17.197 36.3552 18.058 36.3552C18.877 36.3552 19.801 36.0332 19.801 35.0602C19.801 34.7592 19.612 34.2272 18.877 34.0802C18.7715 34.0572 18.6566 34.0363 18.5398 34.0151C18.0524 33.9264 17.533 33.8319 17.533 33.5552C17.533 33.3032 17.848 33.2822 18.044 33.2822C18.191 33.2822 18.324 33.3102 18.422 33.3732C18.52 33.4362 18.576 33.5342 18.576 33.6882H19.675C19.633 32.7432 18.8 32.5122 18.002 32.5122C17.288 32.5122 16.343 32.7502 16.343 33.6252C16.343 34.4559 17.0171 34.5976 17.6786 34.7366C17.7975 34.7615 17.916 34.7864 18.03 34.8152C18.048 34.8194 18.0672 34.8236 18.0872 34.8281C18.3008 34.8754 18.611 34.9442 18.611 35.2002C18.611 35.4872 18.282 35.5852 18.051 35.5852C17.883 35.5852 17.722 35.5432 17.61 35.4592C17.491 35.3682 17.414 35.2352 17.414 35.0532H16.28ZM21.2476 36.2502H19.9316L21.1916 34.3462L20.0366 32.6172H21.3526L21.8636 33.4852L22.3746 32.6172H23.6346L22.5006 34.3252L23.7886 36.2502H22.4726L21.8426 35.2002L21.2476 36.2502Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1492_2564"
        x1="0"
        y1="0"
        x2="0"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#529778" />
        <stop offset="1" stopColor="#1A754C" />
      </linearGradient>
    </defs>
  </svg>
);

export default Xlsx;
